import { Modal } from "@/components/atoms";
import { UserAccountsInviteForm } from "./UserAccountsInviteForm";
import { UserAccountsRemoveAccess } from "./UserAccountsRemoveAccess";
import { UserAccountsRestoreAccess } from "./UserAccountsRestoreAccess";
import { UserAccountsRoleForm } from "./UserAccountsRoleForm";
import { useUserAccountsContext } from "./contexts/userAccounts";

export const UserAccountsModals = () => {
  const { step, setStep } = useUserAccountsContext();

  return (
    <>
      <Modal open={step === "add"} onClose={() => setStep(undefined)} className="w-[85vw] md:w-[550px] lg:w-[550px]">
        <UserAccountsInviteForm />
      </Modal>
      <Modal open={step === "edit"} onClose={() => setStep(undefined)} className="w-[85vw] md:w-[550px] lg:w-[550px]">
        <UserAccountsRoleForm />
      </Modal>
      <Modal open={step === "delete"} onClose={() => setStep(undefined)}>
        <UserAccountsRemoveAccess />
      </Modal>
      <Modal open={step === "restore"} onClose={() => setStep(undefined)}>
        <UserAccountsRestoreAccess />
      </Modal>
    </>
  );
};
